import { useEffect } from "react";

let lockCount = 0;
let prevBodyOverflow: string | undefined;
let prevHtmlOverflow: string | undefined;
let prevBodyTouchAction: string | undefined;

/**
 * Locks scrolling by hiding overflow on both `body` and `html`.
 * Also disables `touchAction` to reduce background "peek" on mobile browsers.
 *
 * Uses a small reference count so multiple modals/hooks won't fight each other.
 */
export function useScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;
    if (typeof document === "undefined") return;

    if (lockCount === 0) {
      prevBodyOverflow = document.body.style.overflow;
      prevHtmlOverflow = document.documentElement.style.overflow;
      prevBodyTouchAction = document.body.style.touchAction;

      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    }

    lockCount += 1;

    return () => {
      lockCount -= 1;
      if (lockCount > 0) return;

      document.body.style.overflow = prevBodyOverflow ?? "";
      document.documentElement.style.overflow = prevHtmlOverflow ?? "";
      document.body.style.touchAction = prevBodyTouchAction ?? "";

      prevBodyOverflow = undefined;
      prevHtmlOverflow = undefined;
      prevBodyTouchAction = undefined;
    };
  }, [locked]);
}

